export const THEME_STORAGE_KEY = 'tifosi_theme';

export type ColorScheme = 'light' | 'dark';

export function getSystemScheme(): ColorScheme {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function loadStoredPreference(): ColorScheme | null {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* ignore */
  }
  return null;
}

export function resolveScheme(preference: ColorScheme | null): ColorScheme {
  return preference ?? getSystemScheme();
}

export function applyThemeToDocument(scheme: ColorScheme): void {
  document.documentElement.dataset.theme = scheme;
  document.documentElement.style.colorScheme = scheme === 'dark' ? 'dark' : 'light';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', scheme === 'dark' ? '#211111' : '#ea2a33');
  }
}

/** À appeler avant le premier rendu React pour limiter le flash. */
export function hydrateThemeFromStorage(): void {
  if (typeof document === 'undefined') return;
  applyThemeToDocument(resolveScheme(loadStoredPreference()));
}
